import {
  DIM2CLASS
} from '../../core/icon-class';
import {
  Filter
} from '../../common/filter';
import {
  boolDialogCtrl
} from '../../admin/modals';
import {
  getFilterIcon
} from '../../common/filter-mode';
import {
  REG_EXP_PREF_CASE_UNSENSETIVE,
  REG_EXP_PREF
} from '../../common/config';
import {
  RegExpConstructorModalController
} from './regexp-constructor/regexp-constructor-modal.component.js';

require('./filter-editor-modal.component.scss');

export const FilterEditorModalController = function(
  $scope,
  $http,
  $modal,
  $timeout,
  $modalInstance,
  FilterResource,
  Aggregates,
  filter,
  CurrentFilterService,
  FiltersService,
  FilterDataFactory,
  CurrentModelService,
  FilterEditorService,
  model,
  asNew,
  globalAlert,
  ErrorHandlerService,
  StatusCheckerService,
  SpecialModalService,
  RouterService,
  tabName,
) {
  $scope.regExpPref = REG_EXP_PREF;
  $scope.regExpPrefI = REG_EXP_PREF_CASE_UNSENSETIVE;
  $scope.isDark = $scope.$root.theme == 'dark';
  $scope.testMail = true;
  $scope.notify2 = {};
  $scope.$timeout = $timeout;
  $scope.successSended = false;
  let jastOpened = true;
  $scope.model = model;
  $scope.$http = $http;
  $scope.ErrorHandlerService = ErrorHandlerService;
  $scope.CurrentFilterService = CurrentFilterService;
  $scope.RouterService = RouterService;
  $scope.CurrentModelService = CurrentModelService;
  $scope.visibleDimensions = model.dimensions;
  $scope.DIM2CLASS = DIM2CLASS;
  $scope.cube = model.cubes[0];
  $scope.filterAsText = {};
  $scope.awaiting = false;
  $scope.warningMessage = '';
  if (!$scope.ErrorHandlerService.filterErrorMessage)
    $scope.ErrorHandlerService.filterErrorMessage = {};
  $scope.errorMessage = $scope.ErrorHandlerService.filterErrorMessage;
  if (!('fields' in $scope.errorMessage)) $scope.errorMessage.fields = {};
  $scope.errorMessage.filterUnchecked = false;
  $scope.errorMessage.notReload = true;
  $scope.ErrorHandlerService.notShowErrorMessageBox = true;
  $scope.FilterEditorService = FilterEditorService;

  $scope.cancel = () => {
    $scope.ErrorHandlerService.notShowErrorMessageBox = false;
    $modalInstance.dismiss('cancel');
    $scope.ErrorHandlerService.filterErrorMessage = {};
  };

  $scope.groupEdit = tabName === 'groupEdit';
  if ($scope.groupEdit && !FiltersService.isMarked) {
    return $scope.cancel();
  }
  $scope.filterBar = new Filter('DialogBar');
  const createFilter = () => {
    if (!$scope.groupEdit) return angular.copy(filter);
    const newFilter = new Filter(gettext('Группа фильтров'));
    const markedFilters = FiltersService.markedFilters;
    if (!markedFilters.length) return newFilter;
    const markedFilter1 = markedFilters[0];
    markedFilters.splice(0, 1);
    const params = Object.keys(markedFilter1).reduce((prms, k) => {
      const value = markedFilter1[k];
      if (markedFilters.every(f => angular.equals(f[k], value))) {
        prms[k] = value;
      }
      return prms;
    }, {});

    Object.assign(newFilter, params);
    return newFilter;
  };

  $scope.filter = createFilter();
  $scope.filterData = FilterDataFactory(true);
  if (asNew) {
    delete $scope.filter.id;
    $scope.filter.saved = false;
    $scope.CurrentFilterService.setFilterName($scope.filter);
  }

  if ($scope.filter.isCardFilter && $scope.CurrentFilterService.filter.id === $scope.filter.id)
    $scope.filter.children = $scope.CurrentFilterService.filter.children;
  $scope.filterBar.skipStat = true;
  $scope.filterBar.limit = 100;
  $scope.serverPolicies = false;
  $scope.showDeleteButton = true;
  $scope.StatusChecker = StatusCheckerService;

  const tabs = {
    QueryTab: {
      currentTab: 'filters',
      filterTab: 'query'
    },
    notify: {
      currentTab: 'notify',
      filterTab: 'filter'
    },
    groupEdit: {
      currentTab: 'notify',
      filterTab: 'filter'
    },
    filters: {
      currentTab: 'filters',
      filterTab: 'filter'
    },
    code: {
      currentTab: 'filters',
      filterTab: 'code'
    },
    prop: {
      currentTab: 'prop',
      filterTab: 'filter'
    },
    speech_recognition: {
      currentTab: 'speech_recognition',
      filterTab: 'filter'
    }
  };

  if (!(tabName && tabName in tabs)) tabName = 'prop';
  // $scope.RouterService.tabName = tabName;

  $scope.currentTab = tabs[tabName].currentTab;
  $scope.filterTab = tabs[tabName].filterTab;


  $scope.isBlokTabs = () => {
    return $scope.errorMessage.error && $scope.errorMessage.source !== 'policy-limit';
  };


  $scope.setTab = tab => {
    if ($scope.isBlokTabs()) return;
    $scope.currentTab = tab;
    if (tab === 'prop') $scope.RouterService.tabName = 'prop';
    else if (tab === 'filters') $scope.RouterService.tabName = 'filters';
    else if (tab === 'notify') $scope.RouterService.tabName = 'notify';
    else if (tab === 'speech_recognition') $scope.RouterService.tabName = 'speech_recognition';
    $scope.$broadcast('changeTab');
  };

  $scope.setColor = (color, event) => {
    $scope.filter.search_color = color;
  };

  $scope.setFilterTab = tab => {
    if ($scope.isBlokTabs()) return;
    $scope.filterTab = tab;
    if (tab === 'code') $scope.RouterService.tabName = 'code';
    else if (tab === 'filter') $scope.RouterService.tabName = 'filters';
    else if (tab === 'query') $scope.RouterService.tabName = 'QueryTab';
  };
  $scope.colorOpened = false;
  $scope.filter.search_color = String($scope.filter.search_color || 0);

  $scope.setColor = (color, event) => {
    $scope.filter.search_color = color;
  };

  $scope.getOriginalFilter = (id) => {
    if ($scope.originalFilter) return $scope.originalFilter;
    if (!id) id = $scope.filter.id;
    if (!id) return null;
    $scope.originalFilter = FiltersService.findById(id);
    return $scope.originalFilter;
  };

  $scope.emailTemplete = {
    show: false
  };
  $scope.setTrueemailTemplete = () => $scope.emailTemplete.show = true;

  $scope.isFilterChanged = () => {
    if (!$scope.filter.id) {
      $scope.filter.isChanged = true;
    } else {
      $scope.filter.isChanged = !angular.equals($scope.getOriginalFilter(), $scope.filter);
    }
    return $scope.filter.isChanged;
  };

  const bypassTypes = ['filter', 'dashboard', 'folder', 'backupfilter', 'stamprecognition', 'graphicobjects',
    'deletepolicy', 'inactiveagentfilter', 'lateuploadfilter', 'lateagentfilter', 'hardwaredelta', 'letteryourself',
    'dimensioncardfilter', 'generalreportfilter'
  ];
  $scope.showApplyType = () => {
    return !bypassTypes.includes($scope.filter.content_type);
  };

  const initApplyType = () => {
    $scope.filter.applyType = $scope.filter.id ? 'continue' : 'new';
  };

  if ($scope.showApplyType()) initApplyType();

  $scope.isAllFieldsDisabled = $scope.filter.isPolitic && !$scope.filter.do_scan;

  $scope.toggleDo_scan = () => {
    $scope.isAllFieldsDisabled = $scope.filter.isPolitic && !$scope.filter.do_scan;
    if ($scope.showApplyType()) initApplyType();
  };

  $scope.filterIcon = () => getFilterIcon($scope.filter);

  $scope.filterHeader = () => {
    if (!$scope.filter.content_type) return $scope.filter.name;
    const type = $scope.CurrentFilterService.PermissionService.types[$scope.filter.content_type];
    return type && $scope.filter.name !== type.name ? `${type.name}: ${$scope.filter.name}` : `${$scope.filter.name}`;
  };

  $scope.updateAsText = () => {
    $scope.filterAsText.code = $scope.filter.getCutsCode();
    if ($scope.errorMessage.source !== 'query-text') {
      $scope.findFilterError('query-filter');
    }
  };

  $scope.findFilterError = type => {
    if ($scope.errorMessage.error == true) return;
    const setFieldNumError = (field, message = '') => {
      if (!angular.isNumber($scope.filter[field]) || $scope.filter[field] < 0) {
        $scope.errorMessage.fields[field] = gettext('Введите положительное целое число') + message;
        $scope.errorMessage.error = true;
      }
    };

    if ($scope.filter.content_type === 'deletepolicy')
      $scope.warningMessage = gettext('Вы уверены в правильности выбора данных? Удалённые данные восстановить нельзя.');

    $scope.errorMessage.source = type;

    if ($scope.CurrentFilterService.iFrameParams) Object.assign($scope.filter, $scope.CurrentFilterService.iFrameParams);

    if ($scope.filter.content_type === 'lateuploadfilter' || $scope.filter.content_type === 'inactiveagentfilter') {
      $scope.changeFilterTimeout();
      if (!$scope.filter.timeout || $scope.filter.timeout === '0:0') {
        $scope.errorMessage.fields['timeout'] = gettext('Введите данные в формате "чч:мм"');
        $scope.errorMessage.error = true;
      }
    }

    if ($scope.filter.content_type === 'ocrparser' && $scope.filter.action === 'abbyy') {
      if ($scope.filter.ocr_app_id == '' || $scope.filter.ocr_app_password == '') {
        $scope.errorMessage.text = gettext('Укажите AppID и пароль');
        $scope.errorMessage.error = true;
      }
    }

    if (filter.content_type === 'backupfilter') {
      setFieldNumError('hdd_alarm_percentage');
      setFieldNumError('hdd_hard_percentage');
      setFieldNumError('database_alarm_percentage');

      if ($scope.filter.hdd_backup_path == '') {
        $scope.errorMessage.fields['hdd_backup_path'] = gettext('Задайте путь резервного копирования');
        $scope.errorMessage.error = true;
      }
    }

    if ($scope.filter.content_type === 'withdrawallicenseagent') {
      setFieldNumError('inactivity_days');
      setFieldNumError('account_inactivity_days');
    }

    if ($scope.filter.content_type === 'mailgrabber') {
      if ($scope.filter.messages_deletion_policy === undefined) {
        $scope.filter.messages_deletion_policy = '1';
      }
      if ($scope.filter.messages_deletion_policy !== '3') {
        $scope.filter.delete_messages_after_days = null;
      }
      if ($scope.filter.messages_deletion_policy === '3') {
        setFieldNumError('delete_messages_after_days');
      } else {
        $scope.filter.delete_messages_after_days = null;
      }
    }

    if ($scope.filter.name == '') {
      $scope.errorMessage.text = gettext('Задайте имя фильтра');
      $scope.errorMessage.error = true;
    }

    $scope.$broadcast('filter-validation', {
      filter: $scope.filter,
      result: $scope.errorMessage,
    });

    $scope.filter.filters.some(cut => {
      if (cut.dimension !== 'keyword' && !$scope.model.getDimension(cut.dimension)) {
        $scope.errorMessage.source = 'filter-dimensions';
        $scope.errorMessage.error = true;
        $scope.errorMessage.text = gettext('Неверное измерение:') + ' "' + cut.dimension + '"';
        return true;
      }
      return false;
    });

    if ($scope.errorMessage.error) {
      $scope.awaiting = false;
    }

    if (!$scope.errorMessage.error && !$scope.ErrorHandlerService.isWrongCuts($scope.filter.filters)) {
      if (!$scope.errorMessage.error)
        $scope.errorMessage.text = $scope.CurrentModelService.model.checkIsFilterCutsValueAllowed($scope.filter);
    }
    if ($scope.errorMessage.error) {
      $scope.awaiting = false;
    }
    $scope.errorMessage.filterUnchecked = false;
    if ($scope.errorMessage.error) {
      return true;
    }
    $scope.CurrentFilterService.getFilterError($scope.filter)
      .then(filterError => {
        if (filterError.error) {
          $timeout(() => {
            Object.assign($scope.errorMessage, filterError);
          }, 100);
        }
      });

  };

  $scope.$watch('filter', () => {
    if ($scope.errorMessage.error && $scope.errorMessage.source == 'query-regexp') return;
    Object.keys($scope.errorMessage).map(k => delete $scope.errorMessage[k]);
    $scope.errorMessage.fields = {};
    $scope.findFilterError('data-filter');
    $scope.updateAsText();
    if (jastOpened) jastOpened = false;
    else if ($scope.filter.isPolitic) $scope.filterData.update($scope.filter);
  }, true);

  $scope.updateFromText = () => {
    $scope.warningMessage = '';
    $scope.filter.from_text($scope.filterAsText.code);
    $scope.findFilterError('data-filter');
    queryAsTextChange();
  };

  $scope.onQueryTextGotFocus = () => {
    $scope.warningMessage = gettext('Для сохранения кода фильтра переместите фокус мышки из текстового редактора на любую другую часть формы');
  };

  const isValidQueryText = text => {
    return !!text.match(/(?=.*\boperator\b)*(?=.*\brules\b)/);
  };

  const queryAsTextChange = () => {
    try {
      const query = Filter.getQueryFromText($scope.filterAsText.code);
      Object.keys($scope.filter.query).map(k => delete $scope.filter.query[k]);
      Object.assign($scope.filter.query, query);
    } catch (err) {
      $scope.errorMessage.text = err.message;
      $scope.errorMessage.source = 'query-text';
      console.error(err.message);
    }
  };

  $scope.openNodes = {};

  $scope.locLabel = Filter.locLabel;
  $scope.locLabel1 = Filter.locLabel1;

  $scope.isNodeOpen = function(type, obj) {
    return $scope.openNodes[type] == obj;
  };

  $scope.closeNode = function(type, obj) {
    $scope.openNodes[type] = false;
  };

  $scope.switchNode = function(type, obj, $event) {
    if ($scope.isNodeOpen(type, obj)) $scope.closeNode(
      type,
      obj,
    );
    else $scope.openNode(type, obj);
    if ($event) $event.stopPropagation();
  };

  $scope.openNode = function(type, obj) {
    $scope.closeNode(type, obj);
    $scope.openNodes[type] = obj;
  };

  $scope.cells = function() {
    return $scope.aggregate ? $scope.aggregate.cells : [];
  };

  $scope.loadAggregate = function(callback, resetCache) {
    if ($scope.aggregate) {
      $scope.aggregate.blocked = true;
    }
    if (resetCache) $scope.filterBar.page = 0;
    const canceler = null;
    $scope.filterBar.copyFrom($scope.filter, true);
    delete $scope.filterBar.timeFrom;
    delete $scope.filterBar.timeTo;
    $scope.drill = $scope.filterBar.drilldown[0];

    if ($scope.filter.content_type === 'backupfilter' || $scope.filter.content_type === 'withdrawallicenseagent') {
      $scope.serverPolicies = true;
    }

    if (!$scope.groupEdit && (!$scope.filter.id || $scope.filter.id < 1000 || $scope.serverPolicies)) {
      $scope.showDeleteButton = false;
    }

    if ($scope.aggregate && $scope.filterBar.page === 0) {
      $scope.aggregate = null;
    }
    $scope.drill = $scope.filterBar.drilldown[0];
    Aggregates.load(
        $scope.cube.name,
        $scope.filterBar,
        resetCache,
        canceler,
      )
      .then((aggregate) => {
        if (aggregate) {
          if (!$scope.aggregate || !$scope.filterBar.page) {
            $scope.aggregate = aggregate;
            $scope.aggregate.isComplete = false;
          } else {
            $scope.aggregate.isComplete = aggregate.cells.length == 0;
            aggregate.cells.forEach(function(cell) {
              $scope.aggregate.cells.push(cell);
            }, this);
          }
        }
        if ($scope.aggregate) {
          $scope.aggregate.blocked = false;
        }
        $scope.$broadcast('aggregateLoaded');
      })
      .catch(error => {
        ErrorHandlerService.handle(error);
      });
  };

  $scope.aggregate_more = function() {
    if (!$scope.filterBar) return;
    const blocked = $scope.aggregate ? $scope.aggregate.blocked : true;
    $scope.filterBar.page = blocked ? $scope.filterBar.page : $scope.filterBar.page + 1;
    if (!blocked) $scope.loadAggregate(function(error) {
      if (error) globalAlert(error.message);
    }, false);
  };

  $scope.searchAggregate = function(event) {
    if (event && event.keyCode != 13) return false;
    const keyword = angular.element('#aggregate-search-modal').val();
    $scope.filterBar.lookup = keyword;
    $scope.loadAggregate(function(error) {
      if (error) globalAlert(error.message);
    }, true);
  };

  $scope.loadAggregate(null, true);

  $scope.isAggregateLoading = function() {
    return !$scope.aggregate || $scope.aggregate.blocked;
  };

  $scope.hasData = function() {
    return ($scope.aggregate && $scope.aggregate.cells && $scope.aggregate.cells.length > 0);
  };


  $scope.dimId = dim => `${(dim.dimension && (dim.dimension.name + '@'))  || ''}${dim.name}`;

  $scope.select = function(dim) {
    if (dim.dimension) {
      $scope.openNode('hierarhy', dim.toString());
      $scope.openNode('dimension', dim.dimension.toString());
    } else {
      $scope.openNode('dimension', dim.toString());
    }
    $scope.filterBar.setDrilldown(dim.toString());
    $scope.filterBar.setKeyword('');
    $scope.filterBar.page = 0;
    $scope.filterBar.lookup = null;
    $scope.loadAggregate();
  };

  $scope.$on('reload', () => $scope.loadAggregate(null, true));

  $scope.hasCellFilter = function(drill, cell) {
    const filter = $scope.model.getCellFilter(drill, cell);
    return $scope.filter.hasFilter(filter);
  };

  $scope.focusName = function() {
    // if (!$scope.filter.saved) {
    //   $scope.filter.name = '';
    // }
  };

  $scope.cleanName = function() {
    $scope.filter.name = '';
  };

  $scope.cleanDescription = function() {
    $scope.filter.description = '';
  };

  $scope.invertFilter = f => {
    $scope.filter.invertFilter(f);
    $scope.updateAsText();
    $scope.findFilterError('data-filter');
  };

  $scope.keyWordClick = (keyWords, oper) => {
    if (!keyWords || !keyWords.trim()) {
      return;
    }
    const re = (keyWords.match(/["'](.*)["']/));

    if (re) {
      $scope.filter.addKeyword(`${oper}${re[1]}`);
    } else {
      keyWords.split(' ').forEach((keyword) => {
        $scope.filter.addKeyword(`${oper}${keyword}`);
      });
    }
    $scope.updateAsText();
  };

  $scope.removeFilter = f => {
    $scope.filter.removeFilter(f);
    $scope.updateAsText();
    $scope.findFilterError('data-filter');
  };

  $scope.setCellFilter = (drill, cell) => {
    const filter = $scope.model.getCellFilter(drill, cell);
    $scope.filter.toggleFilter(filter);
    $scope.updateAsText();
    $scope.findFilterError('data-filter');
  };

  $scope.selectAll = () => {
    if (!$scope.aggregate || !$scope.aggregate.cells) {
      return;
    }
    const drill = $scope.filterBar.drilldown[0];
    const cells = $scope.aggregate.cells;
    cells.forEach(cell => {
      const filter = $scope.model.getCellFilter(drill, cell);
      $scope.filter.toggleFilter(filter);
    });
    $scope.CurrentFilterService.rebuildVisibleDimensions();
    $scope.RouterService.filterChanged();
  };

  const setTimeout = () => {
    if (!$scope.filter.timeout) {
      $scope.timeout = {
        hours: 0,
        minutes: 0
      };
    } else {
      let [h, m] = $scope.filter.timeout.split(':');
      if (!h || isNaN(Number(h))) h = 0;
      if (!m || isNaN(Number(m))) m = 0;
      $scope.timeout = {
        hours: Number(h),
        minutes: Number(m)
      };
    }
  };
  setTimeout();

  $scope.changeFilterTimeout = () => {
    if ($scope.timeout.hours === null) $scope.timeout.hours = 0;
    if ($scope.timeout.minutes === null) $scope.timeout.minutes = 0;
    if ($scope.timeout.minutes > 59) {
      $scope.timeout.minutes = 0;
    }
    if ($scope.timeout.minutes < 0) {
      $scope.timeout.minutes = 59;
    }
    if ($scope.timeout.hours < 0) $scope.timeout.hours = 0;
    $scope.filter.timeout = `${$scope.timeout.hours}:${$scope.timeout.minutes}`;
  };

  $scope.addOkHandler = (handler) => {
    if ($scope.okHandlers === undefined) {
      $scope.okHandlers = [handler];
    } else {
      $scope.okHandlers.push(handler);
    }
  };

  $scope.ok = testMail => {
    function tailHandler(handler) {
      if ($scope.filter.content_type === 'deletepolicy') {
        $modal.open({
            templateUrl: 'boolDialog.html',
            controller: boolDialogCtrl,
            resolve: {
              message: () => gettext('Вы уверены в правильности выбора данных? Удалённые данные восстановить нельзя.')
            },
          })
          .result.then(result => {
            if (result) {
              handler();
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        handler();
      }
    }

    const defaultHandler = () => ok2(testMail);
    const handlers = [tailHandler];

    if ($scope.okHandlers !== undefined && $scope.okHandlers.length > 0) {
      Array.prototype.push.apply(handlers, $scope.okHandlers);
    }

    handlers.reduceRight((handler, current) => handler ? current(handler) : null, defaultHandler);
  };

  const assignData = (flt, fData) => {
    if (!flt) return;
    Object.keys(flt).map(k => delete flt[k]);
    Object.assign(flt, fData);
  };

  const ok2 = testMail => {
    $scope.filter.search_color = Number($scope.filter.search_color);
    $scope.awaiting = true;
    if (testMail) {
      $scope.testMail = false;
      $scope.filter.testmail = true;
    } else {
      delete $scope.filter.testmail;
    }

    if (filter.switch_to && !filter.switch_to.accountConf && !filter.switch_to.agentConf) delete filter.switch_to;
    $scope.successSended = false;
    $scope.findFilterError('save-filter');
    if ($scope.errorMessage.text) {
      return;
    }

    if (testMail && $scope.errorMessage.text) {
      $scope.testMail = true;
    }

    if (asNew && !$scope.filter.id) {
      $scope.filter.id = 0;
    }

    if ($scope.filter.isCardFilter) {
      delete $scope.filter.cardFilter;
      delete $scope.filter.children;
    }
    if ($scope.filter.isFolder) {
      $scope.filter.notify = false;
      $scope.notify2.active = false;
    }
    if ($scope.RouterService.isEditDasboard) {
      $modalInstance.close($scope.filter);
    } else {
      FilterResource.save($scope.filter)
        .then(({
          status,
          data,
          error
        }) => {
          $scope.awaiting = false;

          if (testMail) {
            $scope.testMail = true;
          }

          if (error) {
            $scope.errorMessage.text = '';
            $scope.errorMessage.error = true;
            $scope.errorMessage.source = 'save-filter';
            if (status == -1) {
              ErrorHandlerService.handleServerError({
                status,
                data,
                error
              });
              return {
                status,
                error,
                data,
              };
            }

            if (status === 418 && typeof data == 'object' && Object.keys(data).length) {
              $scope.errorMessage.text = gettext('Проблемы при отправке адресатам') + ': ' +
                Object.keys(data).join('; ');
            } else if (typeof data == 'object') {
              $scope.errorMessage.fields = Object.keys(data).reduce((acc, k) => {
                const text = Array.isArray(data[k]) ? data[k].join(' ') : data[k];
                if (k in $scope.filter) acc[k] = text;
                else $scope.errorMessage.text = `${$scope.errorMessage.text} ${text}`;
                return acc;
              }, {});
            } else {
              ErrorHandlerService.handle(error);
            }
            $scope.$digest();
          } else {
            if (data.id) FiltersService.loadedFilters[data.id] = true;
            let originalFilter = $scope.getOriginalFilter(data.id);
            if (!originalFilter) {
              originalFilter = new Filter();
              Object.assign(originalFilter, data);
            } else {
              assignData(originalFilter, data);
            }
            assignData($scope.CurrentFilterService.filter, data);

            if (asNew || !filter.id || !FiltersService.findById(filter.id)) {
              FiltersService.filters.push(originalFilter);
            }
            $scope.filter = data;
            if (testMail) {
              $scope.successSended = true;
              $scope.$digest();
              if ($scope.filter.notify || $scope.filter.reporting_schedule_type) {
                $scope.$timeout(() => $scope.successSended = false, 10000);
                $scope.$digest();
              }
              // Keep Save button active
              $scope.filter.isChanged = true;
            } else {
              $modalInstance.close(data);
            }
          }
          return {
            status,
            error,
            data,
          };
        }).then(res => {
          if (asNew && !res.error && res.data && res.data.id) {
            FilterResource.saveChildrens(res.data);
          }
        });
    }
  };

  $scope.delete = () => {
    $modal.open({
        templateUrl: 'boolDialog.html',
        controller: boolDialogCtrl,
        resolve: {
          message: () => ''
        },
      })
      .result.then(result => {
        if (result) {
          $scope.awaiting = true;

          if ($scope.RouterService.isEditDasboard) {
            $scope.filter.deleted = true;
            $modalInstance.close($scope.filter);
          } else {
            if ($scope.groupEdit) {
              return FiltersService.deleteFilters(
                  Object.keys(FiltersService._markedFilters)
                  .filter(k => {
                    const n = parseInt(k, 10);
                    return !isNaN(n) && n > 1000;
                  })
                  .map(k => ({
                    id: parseInt(k, 10)
                  })))
                .then(() => {
                  $scope.awaiting = false;
                  $scope.ErrorHandlerService.notShowErrorMessageBox = false;
                  const currFilter = CurrentFilterService.filter;
                  if (FiltersService._markedFilters[currFilter.id]) {
                    currFilter.deleted = true;
                  }
                  FiltersService.cleanMarkedFilters();
                  $modalInstance.close(currFilter);
                });
            } else {
              $scope.filter.deleted = true;
              return FilterResource.delete($scope.filter)
                .then(() => {
                  $scope.awaiting = false;
                  $scope.ErrorHandlerService.notShowErrorMessageBox = false;
                  $modalInstance.close($scope.filter);
                })
                .catch((error) => {
                  $scope.awaiting = false;
                  ErrorHandlerService.handle(error);
                });
            }
          }
        }
      })
      .catch((error) => {
        $scope.awaiting = false;
        console.error(error);
      });
  };

  $scope.show = {
    notify: () => true, // !$scope.filter.send_threshold,
    threshold: () => $scope.filter.send_threshold,
    sendPdf: () => $scope.filter.content_type !== 'policy' && $scope.filter.content_type !== 'corpusprocessfilter',
    splitByUser: () => $scope.filter.content_type !== 'policy' && $scope.filter.content_type !== 'corpusprocessfilter' && !filter.isCardOrDashboard,
    sendOptions: () => true,
    propTab: () => !$scope.groupEdit,
    notifyTab: () => ['filter', 'policy', 'corpusprocessfilter', 'generalreportfilter', 'filteraggregatealertfilter'].includes($scope.filter.content_type) ||
     $scope.filter.isDashboard || $scope.filter.isCard || $scope.groupEdit,
    filtersTab: () => !$scope.groupEdit && !($scope.serverPolicies || ['folder', 'mailgrabber', 'msgraphgrabber',
      'contentprocessing', 'noncomputeractivity', 'inactiveagentfilter',
    ].includes($scope.filter.content_type)),
    category: () => ['policy', 'corpusprocessfilter', 'letteryourself', 'noncomputeractivity'].includes($scope.filter.content_type),
    politicOptions: () => !['mailgrabber', 'msgraphgrabber', 'filter', 'dashboard', 'folder', 'generalreportfilter',
      'filteraggregatealertfilter', 'withdrawallicenseagent', 'dimensioncardfilter', 'noncomputeractivity'
    ].includes($scope.filter.content_type),
    lateUploadFilter: () => $scope.filter.content_type === 'lateuploadfilter' || $scope.filter.content_type === 'inactiveagentfilter',
    corpusprocessfilter: () => $scope.filter.content_type === 'corpusprocessfilter',
    syslogprocessfilter: () => $scope.filter.content_type === 'syslogprocessfilter',
    contentprocessing: () => $scope.filter.content_type === 'contentprocessing',
    assignAgentConfigTab: () => !$scope.groupEdit &&
      ($scope.filter.content_type === 'corpusprocessfilter' ||
        $scope.filter.content_type === 'policy' ||
        $scope.filter.content_type === 'filter' ||
        $scope.filter.content_type === 'filteraggregatealertfilter'),
    speechRecognition: () => $scope.filter.content_type === 'speechrecognition',
    backupfilter: () => $scope.filter.content_type === 'backupfilter',
    mailgrabber: () => $scope.filter.content_type === 'mailgrabber',
    msgraphgrabber: () => $scope.filter.content_type === 'msgraphgrabber',
    ocrparser: () => $scope.filter.content_type === 'ocrparser',
    stamprecognition: () => $scope.filter.content_type === 'stamprecognition',
    graphicobjects: () => $scope.filter.content_type === 'graphicobjects',
    withdrawallicenseagent: () => $scope.filter.content_type === 'withdrawallicenseagent',
    use_cp_service: () => $scope.filter.content_type === 'facedetector',
    emailTemplete: () => $scope.emailTemplete.show,
    newEventsNotify: () => !$scope.filter.isDashboard && !$scope.filter.isCard,
    lens: () => !($scope.errorMessage && $scope.errorMessage.error) && !$scope.groupEdit &&
      ($scope.filter.content_type === 'filter' || $scope.filter.content_type === 'filteraggregatealertfilter') &&
      !$scope.filter.isPolitic && !$scope.filter.isContainer,
    saveAs: () => !$scope.groupEdit && ($scope.filter.isDashboard || $scope.filter.content_type === 'filter' || $scope.filter.content_type === 'corpusprocessfilter' || $scope.filter.content_type === 'policy'),
  };

  $scope.RegExpConstructor = () => {
    const regExpModalInstance = $modal.open({
        template: require('./regexp-constructor/regexp-constructor-modal.component.html'),
        controller: RegExpConstructorModalController,
        windowClass: 'regexp-constructor',
        resolve: {
          regExp: () => '',
          colorNum: () => $scope.filter.search_color,
          comment: () => '',
          showComment: () => false,
          caseSensetiveCheckbox: () => true,
        },
      })
      .result.then(({
        regExp,
        caseSensetive,
      }) => {
        if (regExp) {
          const sign = caseSensetive ? REG_EXP_PREF : REG_EXP_PREF_CASE_UNSENSETIVE;
          $scope.filter.corpus_data = $scope.filter.corpus_data ?
          `${$scope.filter.corpus_data}\n${sign}${regExp}` : `${sign}${regExp}`;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  $scope.apply = {};

  $scope.applyToMarked = () => {
    $scope.awaiting = true;
    const onFilter = ['createIncident', 'createIncidentPattern', 'notifyShTime',
      'createIncidentGroup', 'notifyShMonthDay', 'split_by_user',
      'report_if_filter_data_exists', 'sendMail', 'save_on_disk', 'emails'
    ];
    const onNotify = ['reportType'];
    const notifyParams = {};
    const filterParams = {};
    for (const k in $scope.apply) {
      if (!$scope.apply[k]) continue;
      if (onFilter.includes(k)) filterParams[k] = $scope.filter[k];
      else if (k === 'active') filterParams['notify'] = $scope.filter['notify'];
      else if (k === 'schedule') {
        filterParams['reporting_schedule_type'] = $scope.filter['reporting_schedule_type'];
        filterParams['notifyShMonthDay'] = $scope.filter['notifyShMonthDay'];
      } else if (onNotify.includes(k)) notifyParams[k] = $scope.notify2[k];
      else console.error('Wrong apply notify key:', k);
    }
    const filters = FiltersService.markedFilters.map(f => {
      Object.assign(f, filterParams);
      f.setNotifyType(notifyParams);
      return f;
    });

    FilterResource.saveFilters(filters)
      .then(res => {
        $scope.awaiting = false;
        FiltersService.cleanMarkedFilters();
        $scope.cancel();
        $scope.$digest();
      })
      .catch(e => {
        $scope.awaiting = false;
        $scope.$digest();
        FiltersService.cleanMarkedFilters();
        console.error(e);
      });
  };

  function saveAsModalOpen() {
    return $modal.open({
      template: require('./save-as-modal.component.html'),
      windowClass: 'save-as',
      controller: function($scope, $modalInstance, PermissionService) {
        $scope.permission = PermissionService;
        $scope.type = 'filter';

        $scope.setType = type => {
          $modalInstance.close(type);
        };

        $scope.close = () => {
          $modalInstance.close();
        };
      },
    });

  }

  function saveFilter(type) {
    $scope.cancel();
    $timeout(() => {
      $scope.RouterService.search('editDasboard', null);
      $scope.RouterService.modal = 'new-filter';
      $scope.RouterService.type = type;
      const filter = Object.assign($scope.filter, CurrentFilterService.createNewFilter(null, type));
      if (type === 'filteraggregatealertfilter') {
        filter.setMode('stat');
        filter.send_threshold = true;
      }
      if (!filter.isPolitic) delete filter.do_scan;
      FilterEditorService.saveFilter(true, filter);
    }, 100);
  }

  $scope.saveAs = () => {
    saveAsModalOpen().result
      .then(type => {
        if (type) {
          FiltersService.loadOther($scope.filter.id)
            .then(() => {
              if (type === 'deletepolicy') {
                SpecialModalService.createDeletePolicy(() => saveFilter(type));
              } else saveFilter(type);
              console.log('Open new filter...', type);
            });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  $scope.updateAsText();
};



// WEBPACK FOOTER //
// ./src/filter/editor/filter-editor-modal.component.js